import { render, staticRenderFns } from "./activeActivityList.vue?vue&type=template&id=237ff818&scoped=true"
import script from "./activeActivityList.vue?vue&type=script&lang=js"
export * from "./activeActivityList.vue?vue&type=script&lang=js"
import style0 from "./activeActivityList.vue?vue&type=style&index=0&id=237ff818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ff818",
  null
  
)

export default component.exports